import {createHttpAction} from "../Next/http-fetch";
import {getDeviceTypesIdsNext, getDeviceTypesNext} from "./actionTypes";


export const getDeviceTypesList = (onError) => createHttpAction(getDeviceTypesNext, null, {onError}).action;

export const getDeviceTypesIdsList = (onError) => createHttpAction(getDeviceTypesIdsNext, null, {onError}).action;
